var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJacobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 56,
    viewBox: "0 0 142 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    fill: "url(#paint0_linear_2361_2006)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    stroke: "#8CBEE4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 130,
    height: 44,
    rx: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2361_2006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.364 40.1823H34.5516L31.1438 16.1675H60.9789L71.101 17.4918L80.9702 16.1675H110.771L107.364 40.1823Z",
    fill: "#003C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5362 21.5493L80.9617 16.1677C80.2447 15.5182 79.435 14.9614 78.4902 14.4891C78.2878 16.2351 76.4489 16.9184 74.6185 16.2098C72.9736 15.5772 72.8049 14.5397 72.8049 13.7805C72.8049 13.2238 73.1339 12.5237 73.7918 12.1019L70.9323 9.84131L68.1403 12.1019C68.7982 12.5237 69.1272 13.2238 69.1272 13.7805C69.1272 14.5481 68.9501 15.5772 67.3137 16.2098C65.4917 16.9184 63.6444 16.2267 63.4419 14.4891C62.455 14.9783 61.6959 15.4928 60.962 16.1677L62.3791 21.5493H31.1438L34.5516 46.0618H107.364L110.771 21.5493H79.5362Z",
    fill: "url(#paint1_linear_2361_2006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0415 33.4174C91.4549 33.3583 93.707 33.0631 93.707 30.6001C93.707 27.749 89.9281 27.8249 88.8737 27.8249H84.479V27.8502C84.8164 28.1876 84.9261 28.9889 84.9261 29.6385V38.1158C84.9261 38.7653 84.7911 39.575 84.4874 39.8956V39.9209H90.0546C91.3958 39.9209 94.365 39.381 94.365 36.6396C94.3481 34.1428 92.2731 33.6198 91.0415 33.4174ZM89.1689 38.5966C88.2748 38.5966 87.6591 38.3266 87.6591 38.3266V29.1408H88.9496C89.8016 29.1408 90.8897 29.4782 90.8897 30.8025C90.8897 32.4811 89.6919 33.0378 89.0002 33.0378H88.6713L88.376 34.1513C90.0968 34.1513 91.3536 34.6489 91.3536 36.4962C91.3452 38.276 90.1137 38.5966 89.1689 38.5966Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7397 39.9544V39.9291C48.5457 39.5158 48.706 38.8494 49.0265 38.1156L49.5242 36.9009H54.0117L55.2685 39.9544H58.7185V39.9291C58.263 39.6339 57.7991 38.7145 57.487 37.9637L53.185 27.8247H51.4727L46.3188 39.9629L48.7397 39.9544ZM50.0472 35.6103L51.7595 31.4518L53.4803 35.6103H50.0472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6426 27.8755V29.1323H42.3456C42.3456 31.3086 42.3456 34.0584 42.3456 35.3406C42.3456 39.2123 40.2621 41.1946 37.6641 41.2283L37.1411 41.2367L37.4363 42.3164C37.4954 42.3164 38.0605 42.3164 38.1112 42.3164C42.7589 42.173 45.3401 39.1701 45.3401 33.991V27.8839H38.6426V27.8755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5837 27.5801C73.0747 27.5801 70.2405 29.807 70.2405 33.898C70.2405 38.1577 73.0831 40.1653 76.5837 40.1653C80.0927 40.1653 82.9269 38.0059 82.9269 33.8643C82.9269 29.7479 80.0927 27.5801 76.5837 27.5801ZM76.5753 38.8494C74.458 38.8494 73.4205 36.9599 73.4205 33.8727C73.4205 30.8023 74.593 28.896 76.5921 28.896C78.7262 28.896 79.7637 30.777 79.7637 33.8727C79.7637 36.9346 78.6419 38.8494 76.5753 38.8494Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.529 36.7915C104.656 35.2057 104.15 34.1007 101.155 32.6162C98.979 31.5449 98.3802 31.2665 98.5067 30.1362C98.5826 29.4867 99.2405 28.9047 100.565 28.9047C101.898 28.9047 103.222 29.5711 103.686 30.4652H103.711L104.217 28.5673C103.154 27.9262 102.016 27.6226 100.514 27.6226C98.1355 27.6226 96.0521 28.9216 96.0521 31.0978C96.0521 33.1813 97.4776 33.8814 99.1815 34.7334C100.793 35.5347 101.746 36.0577 101.594 37.3314C101.467 38.4027 100.548 38.816 99.5189 38.816C98.2536 38.816 96.9799 38.2593 96.3726 37.2977H96.3389L95.8496 39.1871C96.9715 39.8872 98.203 40.1403 99.5695 40.1403C101.037 40.1487 104.293 39.7017 104.529 36.7915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8392 33.8895C61.8392 36.6562 63.1888 38.6554 65.6856 38.6638C66.9594 38.6638 68.1909 38.1661 68.6548 37.3479H68.6801L69.1862 39.2458C68.1234 39.8869 66.7569 40.1821 65.2133 40.1821C61.7717 40.1821 58.6592 37.9046 58.6592 33.8895C58.6592 29.8744 61.7717 27.6138 65.2133 27.6138C66.7569 27.6138 68.115 27.909 69.1862 28.5501L68.6801 30.448H68.6548C68.174 29.6213 66.9594 29.1321 65.6856 29.1321C63.1888 29.1405 61.8392 31.1228 61.8392 33.8895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8392 33.8895C61.8392 36.6562 63.1888 38.6554 65.6856 38.6638C66.9594 38.6638 68.1909 38.1661 68.6548 37.3479H68.6801L69.1862 39.2458C68.1234 39.8869 66.7569 40.1821 65.2133 40.1821C61.7717 40.1821 58.6592 37.9046 58.6592 33.8895C58.6592 29.8744 61.7717 27.6138 65.2133 27.6138C66.7569 27.6138 68.115 27.909 69.1862 28.5501L68.6801 30.448H68.6548C68.174 29.6213 66.9594 29.1321 65.6856 29.1321C63.1888 29.1405 61.8392 31.1228 61.8392 33.8895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2309 18.3863L82.9357 18.4622L82.8513 18.1585L83.349 18.0151H83.602V19.6853H83.2309V18.3863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.125 19.2379C84.125 19.0354 84.2178 18.9173 84.4034 18.833C84.2684 18.7571 84.184 18.6474 84.184 18.4703V18.4618C84.184 18.2088 84.4202 18.0063 84.7829 18.0063C85.1457 18.0063 85.3903 18.2088 85.3903 18.4618V18.4703C85.3903 18.6474 85.3059 18.7571 85.171 18.833C85.3481 18.9173 85.4493 19.027 85.4493 19.221V19.2294C85.4493 19.5331 85.171 19.7187 84.7914 19.7187C84.4034 19.7102 84.125 19.5247 84.125 19.2379ZM85.0782 19.2041C85.0782 19.0692 84.9516 18.9933 84.7829 18.9933C84.6142 18.9933 84.4877 19.0692 84.4877 19.1957V19.2041C84.4877 19.3138 84.5974 19.4066 84.7829 19.4066C84.9685 19.415 85.0782 19.3222 85.0782 19.2041ZM85.0276 18.504C85.0276 18.3944 84.9348 18.3016 84.7829 18.3016C84.6311 18.3016 84.5383 18.3944 84.5383 18.4956V18.504C84.5383 18.6221 84.6311 18.7065 84.7829 18.7065C84.9348 18.7065 85.0276 18.6221 85.0276 18.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9047 19.5248L86.1072 19.2464C86.2337 19.3392 86.3349 19.3898 86.4783 19.3898C86.6892 19.3898 86.7988 19.238 86.8242 19.0103C86.7398 19.0777 86.6217 19.1199 86.4783 19.1199C86.1072 19.1199 85.8625 18.9175 85.8625 18.5885V18.5801C85.8625 18.2427 86.1325 17.998 86.5205 17.998C86.7482 17.998 86.8832 18.0487 87.0182 18.1752C87.1447 18.2933 87.2206 18.4704 87.2206 18.7994V18.8078C87.2206 19.3477 86.9591 19.7104 86.4699 19.7104C86.2168 19.7188 86.0481 19.6345 85.9047 19.5248ZM86.8326 18.5716C86.8326 18.4198 86.7229 18.3101 86.5289 18.3101C86.3433 18.3101 86.2337 18.4114 86.2337 18.5632V18.5716C86.2337 18.715 86.3433 18.8247 86.5289 18.8247C86.7229 18.8163 86.8326 18.715 86.8326 18.5716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6252 19.466L87.853 19.2045C87.9795 19.3141 88.1145 19.3816 88.2663 19.3816C88.4435 19.3816 88.5531 19.2973 88.5531 19.1539V19.1454C88.5531 19.002 88.4266 18.9177 88.2494 18.9177C88.1398 18.9177 88.047 18.943 87.9626 18.9767L87.7433 18.8333L87.7939 18.0151H88.8483V18.3357H88.1145L88.0976 18.6225C88.1651 18.6056 88.2241 18.5972 88.3254 18.5972C88.6628 18.5972 88.9243 18.7574 88.9243 19.1286V19.137C88.9243 19.4913 88.6712 19.7106 88.2748 19.7106C87.9964 19.719 87.7939 19.6262 87.6252 19.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9402 18.0322H54.1886V18.3528H53.3029V18.6902H54.0789V19.0191H53.3029V19.365H54.197V19.6855H52.9402V18.0322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.585 19.4488L54.8043 19.1873C54.9561 19.3138 55.1079 19.3897 55.3019 19.3897C55.4538 19.3897 55.5381 19.3307 55.5381 19.2294V19.221C55.5381 19.1282 55.4791 19.0776 55.2007 19.0101C54.8633 18.9258 54.6524 18.833 54.6524 18.504C54.6524 18.2004 54.8971 18.0063 55.2345 18.0063C55.4791 18.0063 55.6815 18.0823 55.8502 18.2172L55.6647 18.4956C55.5213 18.3944 55.3694 18.3353 55.2345 18.3353C55.0911 18.3353 55.0236 18.4028 55.0236 18.4787V18.4872C55.0236 18.5968 55.0911 18.6305 55.3779 18.7065C55.7153 18.7908 55.9008 18.9173 55.9008 19.2041V19.2126C55.9008 19.5415 55.6478 19.7271 55.2935 19.7271C55.0405 19.7102 54.7874 19.6259 54.585 19.4488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6853 18.3696H56.1792V18.0322H57.5541V18.3696H57.048V19.6855H56.6853V18.3696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9592 18.0322H58.6087C59.1317 18.0322 59.486 18.3865 59.486 18.8589V18.8673C59.486 19.3312 59.1233 19.6939 58.6087 19.6939H57.9592V18.0322ZM58.6087 19.3565C58.904 19.3565 59.1064 19.1541 59.1064 18.8589V18.8504C59.1064 18.5552 58.904 18.3528 58.6087 18.3528H58.3304V19.3565H58.6087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9324 17.9814C66.5798 17.9814 63.054 19.736 63.054 21.9038C63.054 24.0716 66.5798 25.8261 70.9324 25.8261C75.2849 25.8261 78.8108 24.0716 78.8108 21.9038C78.8108 19.6853 75.2765 17.9814 70.9324 17.9814ZM77.7986 21.3471C77.419 22.2074 75.6307 23.7258 71.3457 22.6545L70.46 22.4268C66.6389 21.4145 65.0531 22.1231 64.2686 22.7304C64.2011 22.781 64.1337 22.8232 64.0662 22.7895C64.0156 22.7642 64.0156 22.6883 64.0577 22.5955C64.4373 21.7351 66.4027 20.1324 70.6962 21.2037L71.5819 21.423C75.538 22.4268 76.8032 21.8194 77.5877 21.2121C77.6552 21.1615 77.7227 21.1109 77.7901 21.1531C77.8408 21.1868 77.8408 21.2543 77.7986 21.3471Z",
    fill: "#A27D30",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9662 18.6984C75.1332 18.6984 78.541 20.0396 78.8109 22.005C78.8193 21.9207 78.8109 21.811 78.8109 21.7266C78.6591 19.7022 75.3356 17.9814 70.9747 17.9814C66.4956 17.9814 63.1637 19.7613 63.0625 21.8026C63.0625 21.8869 63.0625 22.0472 63.0709 22.1315C63.324 20.1577 66.7908 18.6984 70.9662 18.6984Z",
    fill: "#896B28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2361_2006",
    x1: 73.4244,
    y1: 56,
    x2: 73.335,
    y2: -0.00372781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060B7",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2361_2006",
    x1: 23.5257,
    y1: 27.9517,
    x2: 118.134,
    y2: 27.9517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA9C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0845424,
    stopColor: "#BA9C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2387,
    stopColor: "#E8D09A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2909,
    stopColor: "#E5CE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#DFC88D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3738,
    stopColor: "#D9BF7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4117,
    stopColor: "#CEB26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4479,
    stopColor: "#C1A351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    stopColor: "#BA9C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9735,
    stopColor: "#BA9C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9C40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2361_2006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.5556,
    height: 36.25,
    fill: "white",
    transform: "translate(30.7222 9.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJacobs);
export default __webpack_public_path__ + "static/media/jacobs.8e7950ab83f2e91abfa63574371d2256.svg";
export { ForwardRef as ReactComponent };